import { Injectable, Injector } from '@angular/core';
import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { urls } from '../pages/urls';
import { DataService } from '../pages/data.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private injector: Injector) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let authReq = req;
        const token = localStorage.getItem('token');
        const gatewayDomain = urls.gateway_domain || 'https://catalog-gateway.moglilabs.com';

        // Attach Bearer token if URL contains gateway domain or catalog-gateway and token exists
        if ((req.url.includes(gatewayDomain) || req.url.includes('catalog-gateway')) && token && !req.headers.has('Authorization')) {
            authReq = req.clone({
                headers: req.headers.set('Authorization', `Bearer ${token}`)
            });
        }

        return next.handle(authReq).pipe(
            catchError((error: HttpErrorResponse) => {
                const isGatewayRequest = req.url.includes(gatewayDomain) || req.url.includes('catalog-gateway');
                if (isGatewayRequest) {
                    const dataService = this.injector.get(DataService);
                    dataService.handleGlobalHttpError(error);
                }
                return throwError(error);
            })
        );
    }
}
